import React from 'react'
import styles from './placeholder.styles.scss'

export const PlaceholderMap = () => {
  return (
    <div className={styles.container}>
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      	 viewBox="0 0 600 300" style={{enableBackground:'new 0 0 600 300'}} >
      <g>
      	<g>
      		<rect className="st0" width="600" height="300"/>
      	</g>
      	<g>
      		<defs>
      			<rect id="SVGID_1_" width="600" height="300"/>
      		</defs>
      		<clipPath id="SVGID_00000090991026774617852230000013372642542823664567_">
      			<use href="#SVGID_1_" style={{overflow:'visible'}}/>
      		</clipPath>
      		<g style={{opacity:0.4,clipPath:'url(#SVGID_00000090991026774617852230000013372642542823664567_)'}}>
      			<g>
      				<path className="st2" d="M283.04,152.19l6.64,35.23l10.71,12.12c4.23,4.79,10.32,7.54,16.71,7.54h7.63l16.53-12.85L300,150
      					L283.04,152.19z"/>
      			</g>
      			<g>
      				<path className="st2" d="M114.61,271.99l4.01,30.84l22.46-13.56c3.87-2.34,8.22-3.77,12.72-4.19l56.22-5.24v-40.49l-7.05-6.75
      					L185,251l-51.06,24.51L114.61,271.99z"/>
      			</g>
      			<g>
      				<polygon className="st2" points="507.62,229.14 496.22,213.26 498.11,191.68 534.13,196.62 531.64,209.21 523.38,221.11
      					515.77,226.49"/>
      			</g>
      			<g>
      				<path className="st2" d="M390.79-33.94l2.08,17.6C394.48-2.63,405.61,8.3,419.4,8.95c2.1,0.1,4.24-0.04,6.37-0.5l-11.74-30.89
      					L390.79-33.94z"/>
      			</g>
      			<g>
      				<path className="st3" d="M511.48,266.67c-23.95,0-52.1-7.5-70.68-25.9c-23.22-22.99-25.35-56.54-24.94-79.77
      					c0.06-3.52,0.2-7.15,0.33-10.67c0.6-16.2,1.23-32.94-4.61-46.55c-4.79-11.17-15.67-17.56-33.25-19.55
      					c-15.14-1.71-26.15,5.55-40.05,18.67c-13.21,12.47-25.72,23.14-45.05,27.32c-32.27,6.97-59.75-6.79-86.33-20.11
      					c-5.23-2.62-10.63-5.33-15.88-7.76C138.9,78.16,55.85,61.55-6.65,94.29l-8.35-15.95C14.86,62.7,52.2,55.92,92.98,58.71
      					c35.38,2.43,72.89,12.12,105.62,27.3c5.49,2.55,11.02,5.32,16.37,8c24.89,12.47,48.4,24.25,74.46,18.61
      					c14.82-3.2,24.88-11.85,36.5-22.81c13.56-12.8,30.06-26.23,54.43-23.47c30.19,3.42,42.64,18.39,47.77,30.34
      					c7.43,17.33,6.7,36.98,6.06,54.32c-0.13,3.59-0.26,6.98-0.32,10.32c-0.56,31.68,5.66,52.86,19.6,66.66
      					c17.98,17.8,48.8,22.81,69.82,19.92c11.89-1.63,22.8-8.24,29.18-17.66c3.91-5.78,7.93-15.27,4.85-27.59l-0.13-0.61
      					c-1.72-9.7-6.15-18.57-10.83-27.95c-4.15-8.31-8.43-16.9-11.03-26.53c-5.23-19.41,2.58-39.69,19.9-51.67
      					c17.75-12.27,39.95-12.48,56.56-0.53l-10.51,14.61c-12.58-9.05-27.15-5.27-35.81,0.72c-8.74,6.04-16.68,17.67-12.77,32.18
      					c2.13,7.89,5.83,15.31,9.76,23.17c5.01,10.04,10.19,20.41,12.4,32.54c3.55,14.54,0.9,29.35-7.47,41.74
      					c-9.33,13.8-24.51,23.06-41.64,25.41C521.25,266.35,516.46,266.67,511.48,266.67z"/>
      			</g>
      			<g>
      				<g>
      					<path className="st5" d="M9.24,308.5l-3.38-2.15l71.75-112.77c4.63-7.28,12.86-11.53,21.48-11.08l48.45,2.5
      						c5.27,0.27,10.37-1.77,13.99-5.6l17.03-17.97c2.87-3.03,4.99-6.75,6.13-10.75L218.78,31.1c1.67-5.85,0.92-12.25-2.06-17.55
      						l-15.34-27.35l3.49-1.96l15.34,27.35c3.49,6.23,4.37,13.74,2.42,20.61l-34.08,119.57c-1.32,4.63-3.76,8.92-7.07,12.41
      						l-17.03,17.97c-4.43,4.68-10.67,7.17-17.1,6.84l-48.45-2.5c-7.19-0.38-14.04,3.17-17.9,9.24L9.24,308.5z"/>
      				</g>
      				<g>
      					<path className="st5" d="M324.15,314.25l-81.33-48.55c-14.85-8.86-28.72-19.41-41.23-31.35l-48.92-46.69l2.76-2.89l48.92,46.69
      						c12.29,11.73,25.92,22.1,40.51,30.8l81.33,48.55L324.15,314.25z"/>
      				</g>
      				<g>
      					<path className="st5" d="M446.66,309.12l-140-88.19c-2.18-1.37-4.52-2.49-6.96-3.32l-38.1-12.96c-5.56-1.89-10.65-5.12-14.73-9.35
      						l-56.99-59.12l2.88-2.78l56.99,59.12c3.63,3.77,8.18,6.65,13.13,8.34l38.1,12.96c2.74,0.93,5.36,2.18,7.81,3.72l140,88.19
      						L446.66,309.12z"/>
      				</g>
      				<g>
      					<path className="st5" d="M478.86,59.66c-1.68,0-3.36-0.11-5.04-0.34l-252.53-34.7c-0.87-0.12-1.56-0.8-1.7-1.67
      						c-0.14-0.87,0.31-1.73,1.1-2.11l72.97-35.38l1.75,3.6l-67.03,32.5l245.99,33.8c3.31,0.45,6.66,0.41,9.96-0.15l81.17-13.63
      						c4.28-0.72,8.32-2.25,12-4.54l25.77-16.07l2.12,3.39L579.6,40.43c-4.13,2.57-8.65,4.29-13.45,5.09l-81.17,13.63
      						C482.95,59.49,480.9,59.66,478.86,59.66z"/>
      				</g>
      				<g>
      					<path className="st5" d="M85.16,188.62l-18.5-26.18c-4.63-6.55-7.03-14.57-6.76-22.58l3.04-91.58c0.09-2.71-0.03-5.45-0.36-8.15
      						l-6.64-54.68l3.97-0.48l6.64,54.68c0.35,2.9,0.48,5.84,0.38,8.76l-3.04,91.58c-0.24,7.15,1.9,14.3,6.03,20.14l18.5,26.18
      						L85.16,188.62z"/>
      				</g>
      				<g>
      					<path className="st5" d="M231.04,79.06c-3.23,0-6.46-0.58-9.5-1.72l-12.67-4.76l1.41-3.74l12.67,4.76
      						c3.76,1.41,7.84,1.81,11.8,1.17l173.53-28.39l0.65,3.95L235.4,78.7C233.95,78.94,232.5,79.06,231.04,79.06z"/>
      				</g>
      				<g>
      					<path className="st5" d="M603.02,195.75l-17.12-14.64c-6.01-5.14-9.45-12.62-9.45-20.52v-18.46c0-4.42-1.26-8.72-3.66-12.44
      						l-29.93-46.54c-3.84-5.98-6.51-12.54-7.92-19.51l-18.37-90.64l3.92-0.79l18.37,90.64c1.31,6.48,3.79,12.58,7.37,18.14
      						l29.93,46.53c2.81,4.37,4.29,9.42,4.29,14.6v18.46c0,6.73,2.93,13.1,8.05,17.48l17.12,14.64L603.02,195.75z"/>
      				</g>
      			</g>
      			<g>
      				<path className="st5" d="M452.07,291.85c-3.23,0-6.3-1.18-8.71-3.36l-104.13-94.27l44.75-38.28c6.06-5.18,9.65-12.42,10.1-20.39
      					c0.45-7.96-2.29-15.56-7.73-21.4c-10.68-11.48-28.88-12.3-40.56-1.84l-37.31,33.41c-3.83,3.43-8.54,5.63-13.62,6.36l-46.31,6.7
      					c-3.75,0.54-7.58-0.27-10.79-2.28l-23.04-14.45c-2.51-1.58-5.64-1.81-8.36-0.63l-6.45,2.8l-0.8-1.83l6.45-2.8
      					c3.33-1.44,7.15-1.15,10.22,0.77l23.04,14.45c2.81,1.76,6.16,2.47,9.44,1.99l46.31-6.7c4.69-0.68,9.04-2.71,12.57-5.87
      					l37.31-33.41c12.49-11.18,31.94-10.3,43.36,1.97c5.81,6.24,8.74,14.36,8.26,22.88s-4.32,16.25-10.8,21.79l-43.02,36.8
      					L444.71,287c2.18,1.97,5.01,2.97,7.94,2.83l71.44-3.62c2.71-0.14,5.32-0.78,7.78-1.92l72.04-33.43l0.84,1.81l-72.04,33.43
      					c-2.69,1.25-5.56,1.96-8.52,2.11l-71.44,3.62C452.52,291.84,452.3,291.85,452.07,291.85z"/>
      			</g>
      			<g>
      				<path className="st5" d="M255,242.52c-3.83,0-7.64-0.84-11.13-2.49l-39.86-18.85c-1.25-0.59-2.7-0.5-3.87,0.25l-5.72,3.66
      					l-1.08-1.68l5.72-3.66c1.75-1.12,3.92-1.26,5.8-0.37l39.86,18.85c4.97,2.35,10.64,2.92,15.97,1.61l21.43-5.25
      					c2.98-0.73,5.75-2,8.25-3.79l29.42-21.03l19.5-15.64l-40.02-43.73l1.48-1.35l41.47,45.31L321,211.35l-29.46,21.06
      					c-2.7,1.93-5.71,3.31-8.93,4.1l-21.43,5.25C259.15,242.27,257.07,242.52,255,242.52z"/>
      			</g>
      			<g>
      				<path className="st5" d="M58.53,305.34l-1.19-1.61l43.43-32.19c2.71-2.01,6.14-2.66,9.41-1.78l17.6,4.74
      					c2.53,0.68,5.23,0.44,7.6-0.69l45.63-21.79c1.97-0.94,3.75-2.21,5.29-3.75l15.95-16.06l1.42,1.41l-15.95,16.06
      					c-1.7,1.71-3.67,3.11-5.85,4.15l-45.63,21.79c-2.8,1.34-5.99,1.63-8.98,0.82l-17.6-4.74c-2.67-0.72-5.48-0.19-7.7,1.46
      					L58.53,305.34z"/>
      			</g>
      			<g>
      				<path className="st5" d="M36.37,261.46l-5.4-7.28c-2.16-2.92-3.35-6.38-3.44-10.01l-2.16-90.18c-0.07-2.92,0.51-5.88,1.68-8.56
      					l6.77-15.49c1.67-3.82,4.44-6.98,8-9.15l20.81-12.66h46.63c3.46,0,6.92-0.4,10.28-1.17c6.7-1.55,18.33-4.24,25.18-5.79
      					c3.93-0.89,8.12,0.13,11.21,2.71l36,30.15l-1.28,1.53l-36-30.15c-2.62-2.19-6.16-3.05-9.49-2.3
      					c-6.85,1.55-18.48,4.24-25.17,5.79c-3.51,0.81-7.13,1.23-10.73,1.23H63.2l-20.33,12.37c-3.21,1.95-5.7,4.8-7.2,8.24l-6.77,15.49
      					c-1.05,2.41-1.58,5.08-1.52,7.71l2.16,90.18c0.08,3.22,1.13,6.29,3.05,8.87l5.4,7.28L36.37,261.46z"/>
      			</g>
      			<g>
      				<path className="st5" d="M497.82,88.82c-2.64,0-5.29-0.39-7.8-1.16l-31.83-9.74c-5.61-1.72-10.57-5.3-13.95-10.1l-11.07-15.71
      					l1.66-12.83c0.42-3.22,0-6.51-1.22-9.53l-16.94-42.13l1.86-0.75l16.94,42.13c1.34,3.33,1.8,6.97,1.34,10.53l-1.56,12.06
      					l10.62,15.07c3.13,4.44,7.71,7.75,12.9,9.34l31.83,9.74c3.4,1.04,7.06,1.33,10.59,0.84l26.59-3.71
      					c2.05-0.29,4.06-0.83,5.97-1.62l68.49-28.21L603,54.9l-68.49,28.21c-2.07,0.85-4.24,1.44-6.45,1.75l-26.59,3.71
      					C500.26,88.74,499.04,88.82,497.82,88.82z"/>
      			</g>
      			<g>
      				<path className="st5" d="M500.77,231.1c-10.43,0-20.7-4.75-27.33-13.62l-21.46-28.69c-6.26-8.37-9.29-18.72-8.53-29.14L449.77,73
      					l2,0.15l-6.31,86.65c-0.72,9.94,2.16,19.81,8.13,27.8l21.46,28.69c10.02,13.4,28.89,16.81,42.97,7.77
      					c13.12-8.43,18.26-24.98,12.22-39.36l-5.94-14.14c-2.21-5.26-2.92-11.02-2.07-16.66l10.92-71.85l1.98,0.3l-10.92,71.85
      					c-0.8,5.28-0.13,10.67,1.93,15.59l5.94,14.14c6.42,15.27,0.96,32.86-12.98,41.81C513.45,229.36,507.08,231.1,500.77,231.1z"/>
      			</g>
      			<g>
      				<path className="st5" d="M504.84,144.11c-1.92,0-3.83-0.21-5.72-0.62l-30.77-6.74c-7.47-1.64-13.89-6.4-17.63-13.07l-3.87-6.92
      					l1.75-0.98l3.87,6.92c3.46,6.17,9.4,10.58,16.31,12.09l30.77,6.74c2.91,0.64,5.87,0.74,8.82,0.32l16.76-2.41l0.29,1.98
      					l-16.76,2.41C507.38,144.02,506.11,144.11,504.84,144.11z"/>
      			</g>
      			<g>
      				<path className="st5" d="M170.46,50.24c-3.06,0-6.14-0.55-9.1-1.65L60.61,11.05L26.02-2.11l0.71-1.87L61.31,9.18l100.74,37.54
      					c6.89,2.57,14.45,1.87,20.75-1.93l38.23-23l1.03,1.71l-38.23,23C179.73,48.98,175.11,50.24,170.46,50.24z"/>
      			</g>
      			<g>
      				<path className="st5" d="M220.81,307.95l-9.82-15.76c-1.58-2.54-2.42-5.47-2.42-8.46v-44.77h2v44.77c0,2.62,0.73,5.18,2.12,7.4
      					l9.82,15.76L220.81,307.95z"/>
      			</g>
      			<g>
      				<path className="st5" d="M145.17,56.69c-1.08,0-2.17-0.16-3.23-0.49L87.6,39.34c-1.75-0.54-3.56-0.92-5.38-1.12L48.01,34.4
      					c-4.07-0.45-8.12-0.05-12.02,1.19L-6.95,49.29l-0.61-1.91l42.93-13.69c4.17-1.33,8.5-1.76,12.85-1.28l34.21,3.81
      					c1.95,0.22,3.88,0.62,5.75,1.2l54.34,16.86c4.06,1.26,8.5-0.53,10.55-4.25l34.87-63.27l1.75,0.97l-34.87,63.27
      					C152.86,54.58,149.1,56.69,145.17,56.69z"/>
      			</g>
      			<g>

      					<rect x="24.34" y="52.27" transform="matrix(0.8142 -0.5806 0.5806 0.8142 -58.2327 34.8528)" className="st5" width="2" height="112.29"/>
      			</g>
      			<g>
      				<path className="st5" d="M39.78,158.32c-2.38,0-4.74-0.78-6.65-2.22l-7.04-5.31l1.2-1.6l7.04,5.31c1.9,1.43,4.34,2.06,6.7,1.72
      					l66.22-9.48l0.28,1.98l-66.22,9.48C40.81,158.29,40.3,158.32,39.78,158.32z"/>
      			</g>
      			<g>
      				<path className="st5" d="M328.87,127.13l-1.98-0.28l6.15-44.18c0.91-6.57,3.72-12.66,8.11-17.63l6.67-7.54l1.5,1.32l-6.67,7.54
      					c-4.13,4.67-6.77,10.41-7.63,16.58L328.87,127.13z"/>
      			</g>
      			<g>
      				<path className="st5" d="M366.38,55.63l-1.95-0.45l6.83-29.51c0.32-1.39-0.13-2.85-1.17-3.82l-6.23-5.83
      					c-1.21-1.13-1.9-2.73-1.9-4.38V-8.32h2v19.96c0,1.1,0.46,2.17,1.27,2.92l6.23,5.83c1.56,1.46,2.23,3.66,1.75,5.73L366.38,55.63z
      					"/>
      			</g>
      			<g>
      				<path className="st5" d="M115.61,271.99h-2V260.3c0-1.62-0.28-3.22-0.83-4.74l-17.5-48.62c-1.4-3.9-4.44-6.96-8.32-8.39l-7.99-2.95
      					l0.69-1.88l7.99,2.95c4.44,1.64,7.91,5.14,9.51,9.59l17.5,48.62c0.63,1.74,0.95,3.57,0.95,5.42V271.99z"/>
      			</g>
      			<g>
      				<path className="st5" d="M241.01,75.85l-4.17-16.14c-0.29-1.14-0.7-2.25-1.19-3.31l-14.99-31.96l1.81-0.85l14.99,31.96
      					c0.55,1.17,0.99,2.41,1.32,3.66l4.17,16.14L241.01,75.85z"/>
      			</g>
      			<g>
      				<path className="st5" d="M267.6,205.54l-49.35-6.73c-2.81-0.38-5.45-1.7-7.45-3.71l-31.38-31.5l-50.4-28.18
      					c-3.68-2.06-8.37-1.25-11.16,1.92l-36.68,41.78l-1.5-1.32l36.68-41.78c3.4-3.87,9.14-4.86,13.64-2.34l50.64,28.32l31.57,31.7
      					c1.69,1.7,3.93,2.81,6.31,3.14l48.52,6.61l65.03-50.9c1.64-1.29,4.03-1.08,5.43,0.46l22.45,24.78l-1.48,1.34l-22.45-24.78
      					c-0.7-0.77-1.89-0.88-2.72-0.23L267.6,205.54z"/>
      			</g>
      			<g>
      				<polygon className="st5" points="240.57,307.69 238.65,307.16 249.52,267.84 249.52,240.97 261.23,202.62 259.94,156 261.94,155.94
      					263.23,202.89 263.19,203.05 251.52,241.27 251.48,268.24 				"/>
      			</g>
      			<g>
      				<path className="st5" d="M506.81,229.99l-9.06-12.3c-1.98-2.69-2.85-5.99-2.44-9.31l8.08-65.42l1.99,0.25l-8.08,65.42
      					c-0.35,2.8,0.39,5.6,2.06,7.87l9.06,12.3L506.81,229.99z"/>
      			</g>
      			<g>

      					<rect x="493.21" y="-20.79" transform="matrix(0.9631 -0.2691 0.2691 0.9631 13.59 133.62)" className="st5" width="2" height="76.04"/>
      			</g>
      			<g>
      				<path className="st5" d="M416.62,264.04l-14.6-61.93c-0.49-2.07-2.5-3.39-4.59-3.02c-21.55,3.85-72.2,12.76-77.12,12.48l0.12-2
      					c3.83,0.23,42.11-6.29,76.65-12.46c3.13-0.56,6.16,1.43,6.89,4.53l14.6,61.93L416.62,264.04z"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000168099653445611990150000009135082731752621441_" d="M250.59,69.8c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64C255.8,58.16,250.59,63.37,250.59,69.8"/>
      			</defs>
      			<use href="#SVGID_00000168099653445611990150000009135082731752621441_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000114782574542040929910000006548189388162352035_">
      				<use href="#SVGID_00000168099653445611990150000009135082731752621441_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000114782574542040929910000006548189388162352035_)'}}>
      				<path className="st8" d="M250.72,78.84v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71V73.1c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C250.91,79.5,250.72,79.19,250.72,78.84 M259.25,67.67c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C257.61,71.4,259.25,70.13,259.25,67.67"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000114782574542040929910000006548189388162352035_)'}}>
      				<path className="st8" d="M266.07,78.84v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71V73.1c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C266.26,79.5,266.07,79.19,266.07,78.84 M274.59,67.67c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C272.96,71.4,274.59,70.13,274.59,67.67"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000078020558898334568530000016661449128775004607_" d="M498.47,109.05c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S498.47,102.62,498.47,109.05"/>
      			</defs>
      			<use href="#SVGID_00000078020558898334568530000016661449128775004607_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000057128925717295633230000010251419890173289350_">
      				<use href="#SVGID_00000078020558898334568530000016661449128775004607_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000057128925717295633230000010251419890173289350_)'}}>
      				<path className="st8" d="M498.59,118.09v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C498.79,118.74,498.59,118.44,498.59,118.09 M507.12,106.92c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C505.48,110.65,507.12,109.37,507.12,106.92"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000057128925717295633230000010251419890173289350_)'}}>
      				<path className="st8" d="M513.94,118.09v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C514.14,118.74,513.94,118.44,513.94,118.09 M522.47,106.92c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C520.83,110.65,522.47,109.37,522.47,106.92"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000181781048926076077500000009811990644194633151_" d="M549.78,35.12c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S549.78,28.69,549.78,35.12"/>
      			</defs>
      			<use href="#SVGID_00000181781048926076077500000009811990644194633151_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000124862405362728704290000006875363819580899489_">
      				<use href="#SVGID_00000181781048926076077500000009811990644194633151_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000124862405362728704290000006875363819580899489_)'}}>
      				<path className="st8" d="M549.91,44.16v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C550.11,44.81,549.91,44.51,549.91,44.16 M558.44,32.99c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C556.8,36.71,558.44,35.44,558.44,32.99"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000124862405362728704290000006875363819580899489_)'}}>
      				<path className="st8" d="M565.26,44.16v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C565.46,44.81,565.26,44.51,565.26,44.16 M573.79,32.99c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C572.15,36.71,573.79,35.44,573.79,32.99"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000042009090538762613190000001225872989936041910_" d="M84.11,99.41c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S84.11,92.98,84.11,99.41"/>
      			</defs>
      			<use href="#SVGID_00000042009090538762613190000001225872989936041910_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000118372365033964508180000006084062608562893456_">
      				<use href="#SVGID_00000042009090538762613190000001225872989936041910_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000118372365033964508180000006084062608562893456_)'}}>
      				<path className="st8" d="M84.24,108.45v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C84.43,109.1,84.24,108.8,84.24,108.45 M92.77,97.28c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C91.13,101.01,92.77,99.73,92.77,97.28"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000118372365033964508180000006084062608562893456_)'}}>
      				<path className="st8" d="M99.59,108.45v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C99.78,109.1,99.59,108.8,99.59,108.45 M108.12,97.28c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C106.48,101.01,108.12,99.73,108.12,97.28"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000063614605030448214930000007932101547865269120_" d="M174.81,42.99c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S174.81,36.56,174.81,42.99"/>
      			</defs>
      			<use href="#SVGID_00000063614605030448214930000007932101547865269120_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000077297261971844224050000008054006390787408045_">
      				<use href="#SVGID_00000063614605030448214930000007932101547865269120_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000077297261971844224050000008054006390787408045_)'}}>
      				<path className="st8" d="M174.94,52.03V48.9c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C175.13,52.69,174.94,52.38,174.94,52.03 M183.47,40.86c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C181.83,44.59,183.47,43.32,183.47,40.86"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000077297261971844224050000008054006390787408045_)'}}>
      				<path className="st8" d="M190.29,52.03V48.9c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C190.48,52.69,190.29,52.38,190.29,52.03 M198.82,40.86c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C197.18,44.59,198.82,43.32,198.82,40.86"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000030475437775607627090000002335914959917272485_" d="M37.57,176.93c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S37.57,170.5,37.57,176.93"/>
      			</defs>
      			<use href="#SVGID_00000030475437775607627090000002335914959917272485_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000134957085773358401450000002720347318684950197_">
      				<use href="#SVGID_00000030475437775607627090000002335914959917272485_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000134957085773358401450000002720347318684950197_)'}}>
      				<path className="st8" d="M37.7,185.97v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C37.89,186.63,37.7,186.32,37.7,185.97 M46.23,174.8c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C44.59,178.53,46.23,177.26,46.23,174.8"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000134957085773358401450000002720347318684950197_)'}}>
      				<path className="st8" d="M53.05,185.97v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C53.24,186.63,53.05,186.32,53.05,185.97 M61.58,174.8c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C59.94,178.53,61.58,177.26,61.58,174.8"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000108999657293124616160000017633811155156942211_" d="M213.8,199.99c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S213.8,193.56,213.8,199.99"/>
      			</defs>
      			<use href="#SVGID_00000108999657293124616160000017633811155156942211_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000147942858452233961850000016029480144302843835_">
      				<use href="#SVGID_00000108999657293124616160000017633811155156942211_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000147942858452233961850000016029480144302843835_)'}}>
      				<path className="st8" d="M213.93,209.03v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C214.12,209.68,213.93,209.38,213.93,209.03 M222.46,197.85c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C220.82,201.58,222.46,200.31,222.46,197.85"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000147942858452233961850000016029480144302843835_)'}}>
      				<path className="st8" d="M229.28,209.03v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C229.47,209.68,229.28,209.38,229.28,209.03 M237.81,197.85c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C236.17,201.58,237.81,200.31,237.81,197.85"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000007416246251906719450000009022072693958799508_" d="M406.08,255.95c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64c0-6.43-5.21-11.64-11.64-11.64C411.3,244.31,406.08,249.52,406.08,255.95"/>
      			</defs>
      			<use href="#SVGID_00000007416246251906719450000009022072693958799508_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000180326381506517877870000009219700766650179486_">
      				<use href="#SVGID_00000007416246251906719450000009022072693958799508_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000180326381506517877870000009219700766650179486_)'}}>
      				<path className="st8" d="M406.21,264.99v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C406.41,265.64,406.21,265.33,406.21,264.99 M414.74,253.81c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C413.1,257.54,414.74,256.27,414.74,253.81"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000180326381506517877870000009219700766650179486_)'}}>
      				<path className="st8" d="M421.56,264.99v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C421.76,265.64,421.56,265.33,421.56,264.99 M430.09,253.81c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C428.45,257.54,430.09,256.27,430.09,253.81"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000000215056451764476460000017248893343461878695_" d="M95.75,18.97c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S95.75,12.55,95.75,18.97"/>
      			</defs>
      			<use href="#SVGID_00000000215056451764476460000017248893343461878695_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000046339172042564192930000018213828439308613821_">
      				<use href="#SVGID_00000000215056451764476460000017248893343461878695_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000046339172042564192930000018213828439308613821_)'}}>
      				<path className="st8" d="M95.88,28.01v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C96.08,28.67,95.88,28.36,95.88,28.01 M104.41,16.84c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C102.77,20.57,104.41,19.3,104.41,16.84"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000046339172042564192930000018213828439308613821_)'}}>
      				<path className="st8" d="M111.23,28.01v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C111.42,28.67,111.23,28.36,111.23,28.01 M119.76,16.84c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C118.12,20.57,119.76,19.3,119.76,16.84"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000061430753227945390330000003040225020591732386_" d="M11.15,102.09c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S11.15,95.66,11.15,102.09"/>
      			</defs>
      			<use href="#SVGID_00000061430753227945390330000003040225020591732386_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000176742125201741617510000004296834128971223487_">
      				<use href="#SVGID_00000061430753227945390330000003040225020591732386_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000176742125201741617510000004296834128971223487_)'}}>
      				<path className="st8" d="M11.27,111.13V108c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C11.47,111.78,11.27,111.48,11.27,111.13 M19.8,99.96c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C18.16,103.68,19.8,102.41,19.8,99.96"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000176742125201741617510000004296834128971223487_)'}}>
      				<path className="st8" d="M26.62,111.13V108c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C26.82,111.78,26.62,111.48,26.62,111.13 M35.15,99.96c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C33.51,103.68,35.15,102.41,35.15,99.96"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000140001746185050971420000016661740006736999601_" d="M118.81,244.87c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S118.81,238.45,118.81,244.87"/>
      			</defs>
      			<use href="#SVGID_00000140001746185050971420000016661740006736999601_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000153675187702232029770000008051684649257104305_">
      				<use href="#SVGID_00000140001746185050971420000016661740006736999601_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000153675187702232029770000008051684649257104305_)'}}>
      				<path className="st8" d="M118.94,253.91v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C119.13,254.57,118.94,254.26,118.94,253.91 M127.47,242.74c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C125.83,246.47,127.47,245.2,127.47,242.74"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000153675187702232029770000008051684649257104305_)'}}>
      				<path className="st8" d="M134.29,253.91v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C134.48,254.57,134.29,254.26,134.29,253.91 M142.82,242.74c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C141.18,246.47,142.82,245.2,142.82,242.74"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000097460151799663399740000013731635659550989750_" d="M283.04,85.94c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64C288.25,74.3,283.04,79.52,283.04,85.94"/>
      			</defs>
      			<use href="#SVGID_00000097460151799663399740000013731635659550989750_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000049907375920349811540000005244316957452409252_">
      				<use href="#SVGID_00000097460151799663399740000013731635659550989750_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000049907375920349811540000005244316957452409252_)'}}>
      				<path className="st8" d="M283.17,94.98v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C283.36,95.64,283.17,95.33,283.17,94.98 M291.7,83.81c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C290.06,87.54,291.7,86.27,291.7,83.81"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000049907375920349811540000005244316957452409252_)'}}>
      				<path className="st8" d="M298.52,94.98v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C298.71,95.64,298.52,95.33,298.52,94.98 M307.05,83.81c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C305.41,87.54,307.05,86.27,307.05,83.81"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000083079269921889180830000005134413243207088533_" d="M187.18,176.78c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64S187.18,170.35,187.18,176.78"/>
      			</defs>
      			<use href="#SVGID_00000083079269921889180830000005134413243207088533_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000004521386697109991640000005454434754843726508_">
      				<use href="#SVGID_00000083079269921889180830000005134413243207088533_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000004521386697109991640000005454434754843726508_)'}}>
      				<path className="st8" d="M187.31,185.82v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C187.5,186.48,187.31,186.17,187.31,185.82 M195.84,174.65c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C194.2,178.38,195.84,177.11,195.84,174.65"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000004521386697109991640000005454434754843726508_)'}}>
      				<path className="st8" d="M202.66,185.82v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C202.85,186.48,202.66,186.17,202.66,185.82 M211.19,174.65c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C209.55,178.38,211.19,177.11,211.19,174.65"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000018955414642030776830000006722221780129408409_" d="M465.95,49.36c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64C471.16,37.71,465.95,42.93,465.95,49.36"/>
      			</defs>
      			<use href="#SVGID_00000018955414642030776830000006722221780129408409_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000021079077930316278230000017856808201033701009_">
      				<use href="#SVGID_00000018955414642030776830000006722221780129408409_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000021079077930316278230000017856808201033701009_)'}}>
      				<path className="st8" d="M466.08,58.39v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C466.27,59.05,466.08,58.74,466.08,58.39 M474.61,47.22c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C472.97,50.95,474.61,49.68,474.61,47.22"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000021079077930316278230000017856808201033701009_)'}}>
      				<path className="st8" d="M481.43,58.39v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C481.62,59.05,481.43,58.74,481.43,58.39 M489.96,47.22c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C488.32,50.95,489.96,49.68,489.96,47.22"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000041984223442887137910000002706246971773218202_" d="M297.45,256.37c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64c0-6.43-5.21-11.64-11.64-11.64C302.66,244.73,297.45,249.94,297.45,256.37"/>
      			</defs>
      			<use href="#SVGID_00000041984223442887137910000002706246971773218202_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000095339304937684922460000008478647617891964831_">
      				<use href="#SVGID_00000041984223442887137910000002706246971773218202_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000095339304937684922460000008478647617891964831_)'}}>
      				<path className="st8" d="M297.57,265.41v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C297.77,266.06,297.57,265.76,297.57,265.41 M306.1,254.24c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C304.46,257.96,306.1,256.69,306.1,254.24"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000095339304937684922460000008478647617891964831_)'}}>
      				<path className="st8" d="M312.92,265.41v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C313.12,266.06,312.92,265.76,312.92,265.41 M321.45,254.24c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C319.81,257.96,321.45,256.69,321.45,254.24"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000177464989431500636550000013789198120574593187_" d="M368,193.86c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64C373.21,182.22,368,187.43,368,193.86"/>
      			</defs>
      			<use href="#SVGID_00000177464989431500636550000013789198120574593187_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000092434393600776802420000014451890843785780913_">
      				<use href="#SVGID_00000177464989431500636550000013789198120574593187_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000092434393600776802420000014451890843785780913_)'}}>
      				<path className="st8" d="M368.13,202.9v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C368.32,203.55,368.13,203.25,368.13,202.9 M376.66,191.73c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C375.02,195.46,376.66,194.18,376.66,191.73"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000092434393600776802420000014451890843785780913_)'}}>
      				<path className="st8" d="M383.48,202.9v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C383.67,203.55,383.48,203.25,383.48,202.9 M392.01,191.73c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C390.37,195.46,392.01,194.18,392.01,191.73"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000146480683403594868700000010579216838189553845_" d="M454.31,160.79c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64C459.52,149.15,454.31,154.36,454.31,160.79"/>
      			</defs>
      			<use href="#SVGID_00000146480683403594868700000010579216838189553845_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000021814797137751227950000002072268200368907148_">
      				<use href="#SVGID_00000146480683403594868700000010579216838189553845_"  style={{overflow:'visible'}}/>
      			</clipPath>
      			<g style={{clipPath:'url(#SVGID_00000021814797137751227950000002072268200368907148_)'}}>
      				<path className="st8" d="M454.44,169.83v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C454.63,170.49,454.44,170.18,454.44,169.83 M462.97,158.66c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C461.33,162.39,462.97,161.12,462.97,158.66"/>
      			</g>
      			<g style={{clipPath:'url(#SVGID_00000021814797137751227950000002072268200368907148_)'}}>
      				<path className="st8" d="M469.79,169.83v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
      					c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
      					c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
      					h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
      					C469.98,170.49,469.79,170.18,469.79,169.83 M478.31,158.66c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
      					c0,2.46,1.51,3.73,3.28,3.73C476.68,162.39,478.31,161.12,478.31,158.66"/>
      			</g>
      		</g>
      	</g>
      	<g>
      		<g>
      			<defs>
      				<path id="SVGID_00000117673464581508800090000002264663851196481195_" d="M553.57,239.8c0,6.43,11.64,20.64,11.64,20.64
      					s11.64-14.22,11.64-20.64s-5.21-11.64-11.64-11.64C558.78,228.16,553.57,233.37,553.57,239.8"/>
      			</defs>
      			<use href="#SVGID_00000117673464581508800090000002264663851196481195_" data-id="pin" style={{overflow:'visible'}}/>
      			<clipPath id="SVGID_00000007419325193873158130000016595659487019784096_">
      				<use href="#SVGID_00000117673464581508800090000002264663851196481195_"  style={{ overflow:'visible' }}/>
      			</clipPath>
            <g style={{clipPath:'url(#SVGID_00000007419325193873158130000016595659487019784096_)'}}>
            	<path className="st8" d="M553.7,248.84v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
            		c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
            		c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
            		h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
            		C553.89,249.5,553.7,249.19,553.7,248.84 M562.23,237.67c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
            		c0,2.46,1.51,3.73,3.28,3.73C560.59,241.4,562.23,240.13,562.23,237.67"/>
            </g>
            <g style={{clipPath:'url(#SVGID_00000007419325193873158130000016595659487019784096_)'}}>
            	<path className="st8" d="M569.05,248.84v-3.13c0-0.4,0.35-0.65,0.64-0.46c1.01,0.64,2.63,1.35,4.34,1.35c2.66,0,3.86-1.36,3.99-3.83
            		c0-0.01,0-0.02,0-0.02c0.07-0.42-0.39-0.64-0.59-0.29c-0.93,1.62-2.54,2.45-4.4,2.45c-3.28,0-5.52-2.71-5.52-7.29
            		c0-4.44,2.26-7.4,5.33-7.4c2.52,0,3.96,1.78,4.72,3.22c0.18,0.34,0.62,0.16,0.59-0.24l-0.1-1.77c-0.02-0.41,0.25-0.76,0.59-0.76
            		h2.3c0.33,0,0.59,0.32,0.59,0.71v11.72c0,5.11-2.82,7.35-6.91,7.35c-2.02,0-3.63-0.32-5.11-0.84
            		C569.24,249.5,569.05,249.19,569.05,248.84 M577.58,237.67c0-2.43-1.62-3.62-3.34-3.62c-1.76,0-3.28,1.19-3.28,3.62
            		c0,2.46,1.51,3.73,3.28,3.73C575.94,241.4,577.58,240.13,577.58,237.67"/>
            </g>

      		</g>
      	</g>
      </g>
      </svg>
    </div>
  )
}
